{
  "required": "Necesario",
  "must_be_less_than": "Debe tener {{ characters }} caracteres o menos",
  "problem_with_our_servers": "Se ha producido un problema con nuestros servidores. Vuelva a intentarlo más tarde.",
  "problem_with_our_servers_code": "Se ha producido un problema con nuestros servidores. El código de error es {{ code }}",
  "problem_with_data_submitted": "Se ha producido un problema con los datos que se han enviado al servidor",
  "connecting_with_our_servers": "Se ha producido un problema al conectarse a nuestros servidores. Vuelva a intentarlo más tarde.",
  "timeout_connecting_servers": "Se ha agotado el tiempo de espera de tu solicitud. Por favor, inténtalo de nuevo.",
  "internet_connection_issue": "Hay un problema con la conexión al servidor. Compruebe su conexión a Internet",
  "copy_code": "Copie el código",
  "polygon_edit_error": "Los polígonos deben tener al menos 3 nodos",
  "linestring_edit_error": "Las líneas deben tener al menos 2 nodos",
  "unknown_edit_error": "Se ha producido un error desconocido",
  "billing_error": "Se ha producido un problema con la facturación de tu proyecto",
  "service_unavailable": "Este servicio no está disponible en este momento. Póngase en contacto con un administrador del proyecto",
  "three_nested": "No puede crear una carpeta con más de 3 niveles de profundidad",
  "error": "Error",
  "invalidLink": "Enlace no válido",
  "error_boundaries": {
    "title_large": "¡Vaya! Algo salió mal.",
    "title_small": "¡Algo salió mal!",
    "error_message": "Algo ha ido mal y nuestro equipo ha sido alertado. Si el problema persiste, ponte en contacto con el servicio de asistencia en ",
    "error_code": "Código de error: {{ code }}",
    "contact": "Póngase en contacto con nosotros",
    "refresh": "Actualizar",
    "reload": "Recargar",
    "webgl_error_title": "Se detectó un error de WebGL",
    "webgl_error_message": "Su navegador o dispositivo no es compatible con WebGL, que es necesario para ver este plan.",
    "webgl_support_message": "Es posible que puedas encontrar orientación sobre cómo habilitar WebGL aquí: ",
    "webgl_error_contact": "Si el problema persiste, ponte en contacto con el servicio de asistencia en ",
    "version_error_title": "Está disponible una nueva versión de Iventis",
    "version_error_message": "Actualice su navegador para cargar la versión más reciente de Iventis.",
    "connection_error_title": "Error de conexión",
    "connection_error_message": "Se ha producido un problema con la conexión. Comprueba tu conexión a Internet e inténtalo de nuevo."
  },
  "digital_twin": {
    "capacity": "La capacidad del servidor para el gemelo digital es insuficiente. Vuelva a intentarlo más tarde o póngase en contacto con {{ supportEmail }} para obtener más información",
    "occupied": "El gemelo digital está ocupado actualmente. Vuelva a intentarlo más tarde.",
    "afk": "Se ha desconectado del gemelo digital debido a la inactividad.",
    "connection_failed": "No se pudo conectar al servicio de gemelos digitales. Vuelva a intentarlo más tarde.",
    "generic": "Se ha producido un problema con el servicio de gemelos digitales. Vuelve a intentarlo más tarde."
  },
  "custom_network_error": {
    "create": {
      "title": "No se pudo crear {{ entity }}",
      "message": "No se guardó la creación de {{ entity }}"
    },
    "update": {
      "title": "No se pudo actualizar {{ entity }}",
      "message": "No se guardaron tus cambios en la {{ entity }}"
    },
    "import_error": {
      "title": "No se pudo importar {{ entity }}",
      "message": "Tus {{ entity }} no se importaron"
    },
    "export_error": {
      "title": "No se pudo exportar {{ entity }}",
      "message": "Tu {{ entity }} no se exportó"
    },
    "delete_error": {
      "title": "No se pudo eliminar {{ entity }}",
      "message": "Tu {{ entity }} no se ha eliminado"
    },
    "generic": {
      "title": "No se pudo {{ action }}",
      "message": "Tu solicitud a {{ action }} no se ha realizado correctamente"
    }
  }
}